import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styletron-react';
const StyledDynamicTableLayout = styled('table', {
    borderCollapse: 'collapse',
    whiteSpace: 'nowrap',
    width: '100%',
});
export const DynamicTableLayout = ({ children }) => {
    return _jsx(StyledDynamicTableLayout, { children: children });
};
